import { render } from "./StartModal.vue?vue&type=template&id=df06fb78&ts=true"
import script from "./StartModal.vue?vue&type=script&lang=ts"
export * from "./StartModal.vue?vue&type=script&lang=ts"

import "./StartModal.vue?vue&type=style&index=0&id=df06fb78&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__